import styled from "styled-components";
import { screenSizes } from "@streeteasy/design-system";

import SEModal from "../../../../shared/components/SEModal";

export const CloseButtonWrapper = styled.div`
  position: absolute;
  right: 27px;
  top: 27px;
`;

export const Modal = styled(SEModal)`
  background: rgba(0, 0, 0, 0.2);
  bottom: 0 !important;
  margin: 0;
  right: 0 !important;
  top: 0 !important;
  width: 480px;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    height: 100vh;
    margin-top: 0;
    width: 100%;
  }
`;

export const Content = styled.div`
  padding: 40px;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    padding: ${props => (props.isIos ? "40px 40px 140px" : "40px")};
  }
`;
